module.exports = __webpack_public_path__ + "static/media/choithramsUserG.964283ad.png";